import _each from "lodash/each";
import _omit from "lodash/omit";
import uuid from 'uuid';
var state = {
  snackbars: {}
};

var reject = function reject(id) {
  return _omit(state.snackbars, id);
};

var dismissExcept = function dismissExcept(id) {
  return function () {
    return _each(reject(id), function (snackbar) {
      return snackbar.dismiss();
    });
  };
};

var deregister = function deregister(id) {
  return function () {
    state.snackbars = reject(id);
  };
};

var register = function register(snackbar) {
  var id = uuid();
  state.snackbars[id] = snackbar;
  return {
    dismissAll: dismissExcept(id),
    deregister: deregister(id)
  };
};

export default register;